<template>
    <form action="https://secure.paygate.co.za/payweb3/process.trans" method="POST" ref="paygateForm" >
        <input type="hidden" name="PAY_REQUEST_ID" :value="paygateResponse.pay_request_id">
        <input type="hidden" name="CHECKSUM" :value="paygateResponse.checksum">
    </form>
</template>

<script>
    export default {
        name: "PaygateButton",
        props: {
            paygateResponse: {
                required: true,
                type: Object
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.paygateForm.submit();
            });

        }

    }
</script>

<style scoped>
    .center {
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -50px;
        margin-left: -100px;
    }
</style>
